import React, { useEffect } from 'react';
import Footer from '../components/Footer';

const Sitemap = ({ navigateToHome, navigateToBlog, navigateToB2B, sitemapData, navigateToPrivacy, navigateToTerms, navigateToAbout, navigateToSitemap }) => {
  // SEO setup for Sitemap page
  useEffect(() => {
    document.title = "Sitemap - FogPortál.hu | Fogászati portál oldaltérkép";
    
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.getElementsByTagName('head')[0].appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'FogPortál.hu sitemap - Minden elérhető városra és kerületre szóló fogorvos és fogászat lista oldalaink áttekintése.');
  }, []);

  const navigateToStaticPage = (url) => {
    window.location.href = url;
  };

  // Generate static page URLs (SEO-friendly, no accents)
  const generateStaticUrl = (city, district = null) => {
    // Clean city name - remove accents and special characters
    const cleanCity = city
      .toLowerCase()
      .replace(/[áäàâã]/g, 'a')
      .replace(/[éëèê]/g, 'e')
      .replace(/[íïìî]/g, 'i')
      .replace(/[óöòôõ]/g, 'o')
      .replace(/[úüùû]/g, 'u')
      .replace(/[ý]/g, 'y')
      .replace(/[ñ]/g, 'n')
      .replace(/[ç]/g, 'c')
      .replace(/[ő]/g, 'o')
      .replace(/[ű]/g, 'u')
      .replace(/[^a-z0-9]/g, '')
      .trim();

    let url = `/fogorvos-${cleanCity}`;
    if (district) {
      // Extract Roman numeral and convert to Arabic
      const romanMatch = district.match(/([IVX]+)\./);
      if (romanMatch) {
        const romanToArabic = {
          'I': '1', 'II': '2', 'III': '3', 'IV': '4', 'V': '5',
          'VI': '6', 'VII': '7', 'VIII': '8', 'IX': '9', 'X': '10',
          'XI': '11', 'XII': '12', 'XIII': '13', 'XIV': '14', 'XV': '15',
          'XVI': '16', 'XVII': '17', 'XVIII': '18', 'XIX': '19', 'XX': '20',
          'XXI': '21', 'XXII': '22', 'XXIII': '23'
        };
        const arabic = romanToArabic[romanMatch[1]];
        if (arabic) {
          url += `-${arabic}-kerulet`;
        }
      }
    }
    return url;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Modern Header */}
      <header className="bg-white shadow-lg border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <button 
                onClick={navigateToHome}
                className="flex items-center space-x-3"
              >
                <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-green-600 rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 2.21 1.79 4 4 4s4-1.79 4-4v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2 15c0 1.1-.9 2-2 2s-2-.9-2-2v-1h4v1zm1.46-4.86C14.8 12.64 14 13.26 14 14v1h-4v-1c0-.74-.8-1.36-1.46-.86C7.06 12.5 6 10.84 6 9c0-3.31 2.69-6 6-6s6 2.69 6 6c0 1.84-1.06 3.5-2.54 4.14z"/>
                  </svg>
                </div>
                <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">
                  FogPortál.hu
                </h1>
              </button>
            </div>

            <nav className="hidden md:flex items-center space-x-1">
              <button 
                onClick={navigateToHome}
                className="px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg font-medium text-sm transition-all duration-200"
              >
                Főoldal
              </button>
              {/* TEMPORARILY HIDDEN - Blog Menu Item */}
              {/* <button 
                onClick={navigateToBlog}
                className="px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg font-medium text-sm transition-all duration-200"
              >
                Blog
              </button> */}
              <button 
                onClick={navigateToB2B}
                className="px-4 py-2 bg-gradient-to-r from-blue-600 to-green-600 text-white rounded-lg font-medium text-sm hover:from-blue-700 hover:to-green-700 transition-all duration-200 shadow-md hover:shadow-lg ml-2"
              >
                Megjelenés fogászatoknak
              </button>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="bg-gradient-to-r from-blue-600 to-green-600 text-white p-8">
            <h1 className="text-4xl font-bold">Oldaltérkép</h1>
            <p className="text-xl mt-2 opacity-90">Minden fogorvos és fogászat lista oldalaink áttekintése</p>
          </div>

          <div className="p-8">
            {/* Budapest Section */}
            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 border-b-2 border-blue-600 pb-2">
                Budapest
              </h2>
              
              <div className="mb-8">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">Általános Budapest fogorvosok</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <button
                    onClick={() => navigateToStaticPage('/fogorvos-budapest')}
                    className="text-left p-4 border border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-all duration-200"
                  >
                    <div className="text-blue-600 font-semibold">Fogorvos Budapest</div>
                    <div className="text-sm text-gray-600 mt-1">Minden budapesti fogorvos és fogászat</div>
                  </button>
                </div>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-4">Budapest kerületek</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {sitemapData.districts.map((district) => {
                    const url = generateStaticUrl('budapest', district.name);
                    const displayName = `Fogorvos Budapest ${district.name.replace(/([IVX]+)\./, (match, roman) => {
                      const romanToArabic = {
                        'I': '1', 'II': '2', 'III': '3', 'IV': '4', 'V': '5',
                        'VI': '6', 'VII': '7', 'VIII': '8', 'IX': '9', 'X': '10',
                        'XI': '11', 'XII': '12', 'XIII': '13', 'XIV': '14', 'XV': '15',
                        'XVI': '16', 'XVII': '17', 'XVIII': '18', 'XIX': '19', 'XX': '20',
                        'XXI': '21', 'XXII': '22', 'XXIII': '23'
                      };
                      return romanToArabic[roman] + '.';
                    })}`;

                    return (
                      <button
                        key={district.id}
                        onClick={() => navigateToStaticPage(url)}
                        className="text-left p-4 border border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-all duration-200"
                      >
                        <div className="text-blue-600 font-semibold">{displayName}</div>
                        <div className="text-sm text-gray-600 mt-1">Budapest {district.name} fogorvosok listája</div>
                      </button>
                    );
                  })}
                </div>
              </div>
            </section>

            {/* Other Cities Section */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-6 border-b-2 border-blue-600 pb-2">
                Egyéb városok (ABC sorrendben)
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {sitemapData.cities
                  .filter(city => city.name.toLowerCase() !== 'budapest')
                  .sort((a, b) => a.name.localeCompare(b.name, 'hu'))
                  .map((city) => {
                    const url = generateStaticUrl(city.name);
                    return (
                      <button
                        key={city.id}
                        onClick={() => navigateToStaticPage(url)}
                        className="text-left p-4 border border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-all duration-200"
                      >
                        <div className="text-blue-600 font-semibold">Fogorvos {city.name}</div>
                        <div className="text-sm text-gray-600 mt-1">{city.name} fogorvosok és fogászatok listája</div>
                        <div className="text-xs text-gray-500 mt-1">{city.county}</div>
                      </button>
                    );
                  })}
              </div>
            </section>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <Footer 
        navigateToHome={navigateToHome}
        navigateToBlog={navigateToBlog}
        navigateToB2B={navigateToB2B}
        navigateToPrivacy={() => window.location.href = '/adatvedelem'}
        navigateToTerms={() => window.location.href = '/aszf'}
        navigateToAbout={() => window.location.href = '/rolunk'}
        navigateToSitemap={navigateToSitemap}
      />
    </div>
  );
};

// Static List Page Component

export default Sitemap;
